import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import MultiSelectField from "../Shared/MultiSelectField.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";


const AddItemPopup = ({ globalContext }) => {

    const urlParams = new URLSearchParams(window.location.search);

    const defaultCountryId = urlParams.get("filter[CountryId]") ?? null;
    const presetOperatorName = urlParams.get("operatorName");
    const presetRoleId = Number(urlParams.get("roleId"));

    const [selectedOption, setSelectedOption] = useState("single-operator");

    const [addName, setAddName] = useState(presetOperatorName);
    const [addCountry, setAddCountry] = useState(defaultCountryId);
    const [addCompetentAuthority, setAddCompetentAuthority] = useState(null);
    const [addReference, setAddReference] = useState(null);
    const [addUSAFEINumber, setAddUSAFEINumber] = useState(null);
    const [addEUSRNNumber, setAddEUSRNNumber] = useState(null);
    const [addDUNSNumber, setAddDUNSNumber] = useState(null);
    const [addAddress, setAddAddress] = useState(null);
    const [addZipCode, setAddZipCode] = useState(null);
    const [addCity, setAddCity] = useState(null);
    const [addFirstName, setAddFirstName] = useState(null);
    const [addLastName, setAddLastName] = useState(null);
    const [addEmail, setAddEmail] = useState(null);
    const [addResponsiblePerson, setAddResponsiblePerson] = useState(null);
    const [addMonthsBeforeExpirationReminder, setAddMonthsBeforeExpirationReminder] = useState(null);
    const [addExpiryDate, setAddExpiryDate] = useState(null);




    const [errorAddName, setErrorAddName] = useState(false);
    const [errorAddCountry, setErrorAddCountry] = useState(false);
    const [errorAddCompetentAuthority, setErrorAddCompetentAuthority] = useState(false);
    const [errorAddRoles, setErrorAddRoles] = useState(false);
    const [errorAddReference, setErrorAddReference] = useState(false);
    const [errorAddUSAFEINumber, setErrorAddUSAFEINumber] = useState(false);
    const [errorAddEUSRNNumber, setErrorAddEUSRNNumber] = useState(false);
    const [errorAddDUNSNumber, setErrorAddDUNSNumber] = useState(false);
    const [errorAddAddress, setErrorAddAddress] = useState(false);
    const [errorAddZipCode, setErrorAddZipCode] = useState(false);
    const [errorAddCity, setErrorAddCity] = useState(false);
    const [errorAddFirstName, setErrorAddFirstName] = useState(false);
    const [errorAddLastName, setErrorAddLastName] = useState(false);
    const [errorAddEmail, setErrorAddEmail] = useState(false);
    const [errorAddResponsiblePerson, setErrorAddResponsiblePerson] = useState(false);
    const [errorAddExpiryDate, setErrorAddExpiryDate] = useState(false);
    const [errorAddMonthsBeforeExpirationReminder, setErrorAddMonthsBeforeExpirationReminder] = useState(false);




    const [errorAddingItem, setErrorAddingItem] = useState(null);




    const [isAddingItem, setIsAddingItem] = useState(false);
    const [fieldsConfig, setFieldsConfig] = useState([]); // Facets
    const [formState, setFormState] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);


    const [countries, setCountries] = useState([]);

    const [field_ROLES, setField_ROLES] = useState({});
    const [fieldConfig_ROLES, setFieldConfig_ROLES] = useState([]);
    const [formState_ROLES, setFormState_ROLES] = useState({});

    const dropdownRefs = useRef({});

    const AppContext = globalContext;





    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "" || field == null) {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    const addItem = () => {

        let isValidForm = true;


        setErrorAddingItem(null);

        if (!validFormField(addName, setErrorAddName))
            isValidForm = false;

        if (!validFormField(addCountry, setErrorAddCountry))
            isValidForm = false;

        if (formState_ROLES["roles"].length == 0) {
            setErrorAddRoles(true);
            isValidForm = false;
        }

        if (!isValidForm) {
            setErrorAddingItem("Name, Country and Roles can't be empty");
            return false;
        }



        let newItem = {
            Name: addName,
            CountryId: addCountry,
            Authority: addCompetentAuthority,
            EstablishmentRegistrationReference: addReference,
            PrimaryContactFirstName: addFirstName,
            PrimaryContactLastName: addLastName,
            PrimaryContactEmail: addEmail,
            Address: addAddress,
            City: addCity,
            ZipCode: addZipCode,
            ExpiryDate: addExpiryDate,
            NumberDUNS: addDUNSNumber,
            USANumberFEI: addUSAFEINumber,
            EUNumberSRN: addEUSRNNumber,
            AssignedTo: addResponsiblePerson,
            Months: addMonthsBeforeExpirationReminder,
            Roles: formState_ROLES["roles"],
            CustomFieldsAnswers: AppContext.newItemCustomFieldsAnswers,
        };



        setIsAddingItem(true);

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };




        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {

                    let message = await response.text();

                    if (response.status == 400)
                        throw new Error(message);

                    throw new Error("Unexpected error, refresh and try again");
                }

                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);
                AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingItem(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });


    }



    const loadRoles = () => {

        
        // Roles

        let data = [

            { Id: 1, Role: "Legal Manufacturer" },
            { Id: 2, Role: "Importer" },
            { Id: 3, Role: "Authorised Representative" },
            { Id: 4, Role: "Distributor" },
            { Id: 5, Role: "Physical Manufacturer" },
            { Id: 6, Role: "Reprocessor" },
            { Id: 7, Role: "Relabeler" },
            { Id: 8, Role: "Other" },
            { Id: 9, Role: "System or Procedure Pack Producer (SPPP)" },

        ];

        let roles = { Alias: "roles", Name: "Roles", Items: [], Mandatory: true };
        roles.Items = data.map(item => ({ Text: item.Role, Value: item.Id, Disabled: false, Group: null, Selected: false }));

        setField_ROLES(roles);
        setFieldConfig_ROLES([roles]);

        const selectedRoles = data.some(item => item.Id === presetRoleId) ? [presetRoleId] : [];
        setFormState_ROLES({ roles: selectedRoles });

    }



    const loadCountries = () => {

        let url = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {};

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let countries = data.map(country => ({ id: country.CountryId, name: country.CountryName }));

                countries.sort((a, b) => a.name.localeCompare(b.name));

                let NA = { id: 0, name: "N/A" };

                countries = [NA, ...countries];

                setCountries(countries);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });
    }





    useEffect(() => {

        loadRoles();

        loadCountries();

        const url = new URL(window.location.href);
        let changed = false;
        ["operatorName", "roleId"].forEach((key) => {
            if (url.searchParams.has(key)) {
                url.searchParams.delete(key);
                changed = true;
            }
        });
        if (changed)
            window.history.replaceState({}, document.title, url.toString());

    }, []);




    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}s</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>




            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: "15px",
                    marginTop: "10px"
                }}>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "single-operator"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("single-operator")}
                >
                    <i className="fas fa-building g-mr-5"></i> Add Operator
                </div>

                <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

            </div>




            <div style={{ marginTop: "20px" }}>


                {selectedOption == "single-operator" ?
                    <div style={{ paddingTop: "10px", }}>


                        <div style={{display: "flex", flexDirection: "row"} }>

                            <div style={{flex: 1}}>





                                <div style={{ width: "100%" }}>
                                    Name *
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddName ? " form-field-error" : null}`}
                                        value={addName}
                                        onChange={(e) => setAddName(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddName && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />


                                
                                <SearchableCountrySelect
                                    label="Country *"
                                    value={addCountry}
                                    onChange={setAddCountry}
                                    countries={countries}
                                />

                                {errorAddCountry && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                <br />




                                
                                <div style={{ width: "100%" }}>
                                    Competent Authority
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddCompetentAuthority ? " form-field-error" : null}`}
                                        value={addCompetentAuthority}
                                        onChange={(e) => setAddCompetentAuthority(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddCompetentAuthority && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />







                                

                                {/* ROLES */}


                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_ROLES}
                                        formState={formState_ROLES}
                                        setFormState={setFormState_ROLES}
                                        fieldsConfig={fieldConfig_ROLES}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                    />

                                </div>


                                {errorAddRoles && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                <br />











                                
                                <div style={{ width: "100%" }}>
                                    Reference
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddReference ? " form-field-error" : null}`}
                                        value={addReference}
                                        onChange={(e) => setAddReference(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddReference && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />


                                
                                <div style={{ width: "100%" }}>
                                    USA FEI Number
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddUSAFEINumber ? " form-field-error" : null}`}
                                        value={addUSAFEINumber}
                                        onChange={(e) => setAddUSAFEINumber(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddUSAFEINumber && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />







                                
                                <div style={{ width: "100%" }}>
                                    EU SRN Number
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddEUSRNNumber ? " form-field-error" : null}`}
                                        value={addEUSRNNumber}
                                        onChange={(e) => setAddEUSRNNumber(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddEUSRNNumber && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />







                                
                                <div style={{ width: "100%" }}>
                                    DUNS Number
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddDUNSNumber ? " form-field-error" : null}`}
                                        value={addDUNSNumber}
                                        onChange={(e) => setAddDUNSNumber(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddDUNSNumber && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />






                                
                                <div style={{ width: "100%" }}>
                                    Address
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddAddress ? " form-field-error" : null}`}
                                        value={addAddress}
                                        onChange={(e) => setAddAddress(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddAddress && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />





                                
                                <div style={{ width: "100%" }}>
                                    ZipCode
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddZipCode ? " form-field-error" : null}`}
                                        value={addZipCode}
                                        onChange={(e) => setAddZipCode(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddZipCode && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />


                                
                                <div style={{ width: "100%" }}>
                                    City
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddCity ? " form-field-error" : null}`}
                                        value={addCity}
                                        onChange={(e) => setAddCity(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddCity && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />


                                
                                <div style={{ width: "100%" }}>
                                    First Name
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddFirstName ? " form-field-error" : null}`}
                                        value={addFirstName}
                                        onChange={(e) => setAddFirstName(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddFirstName && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />





                                
                                <div style={{ width: "100%" }}>
                                    Last Name
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddLastName ? " form-field-error" : null}`}
                                        value={addLastName}
                                        onChange={(e) => setAddLastName(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddLastName && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />







                                
                                <div style={{ width: "100%" }}>
                                    Email
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddEmail ? " form-field-error" : null}`}
                                        value={addEmail}
                                        onChange={(e) => setAddEmail(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddEmail && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />






                                
                                <div style={{ width: "100%" }}>
                                    Responsible Person
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddResponsiblePerson ? "form-field-error" : ""
                                            }`}
                                        value={addResponsiblePerson}
                                        onChange={(e) => setAddResponsiblePerson(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">Select User</option>

                                        {AppContext.users.map((user) => (
                                            <option key={user.Id} value={user.Id}>
                                                {user.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddResponsiblePerson && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />



                                
                                <div style={{ width: "100%" }}>
                                    Expiry Date
                                    <br />

                                    <input
                                        className={`form-field-text add-task-field-name ${errorAddExpiryDate ? "form-field-error" : ""
                                            }`}
                                        value={addExpiryDate}
                                        onChange={(e) => setAddExpiryDate(e.target.value)}
                                        style={{ width: "100%" }}
                                        type="date"
                                    />

                                    {errorAddExpiryDate && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />



                                
                                <div style={{ width: "100%" }}>
                                    Number of months before expiration the reminder is sent
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddMonthsBeforeExpirationReminder ? " form-field-error" : null}`}
                                        value={addMonthsBeforeExpirationReminder}
                                        onChange={(e) => setAddMonthsBeforeExpirationReminder(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddMonthsBeforeExpirationReminder && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />







                                {/* CUSTOM FIELDS */}
                                {AppContext.enableCustomFields ? 
                                    <AddItemCustomFields entityType={AppContext.entityTypeId} context={AppContext} />
                                : null}


                                <br />

                                {/* BUTTONS */}

                                <div className="action-button-bar">

                                    <div className="action-button-bar-left">
                                        <button
                                            className="action-button cancel-button"
                                            onClick={() => AppContext.showAddItemPopup(false)}
                                        >
                                            Close
                                        </button>
                                    </div>

                                    <div className="action-button-bar-center">

                                        {errorAddingItem ? <div style={{ color: "#ff5400" }}>Error: {errorAddingItem}</div> : null}

                                    </div>

                                    <div className="action-button-bar-right">
                                        {isAddingItem ? (
                                            <LoadingSpinnerImage />
                                        ) : (
                                            <button
                                                className="action-button save-button"
                                                onClick={addItem}
                                            >
                                                Add Operator
                                            </button>
                                        )}
                                    </div>
                                </div>


                            </div>




                        </div>

                    </div>

                    : null}


                {selectedOption == "bulk-registrations" ?
                    <div style={{ paddingTop: "10px", textAlign: "center", paddingBottom: "30px" }}>
                        <div style={{ fontSize: "11px", textAlign: "left" }}>
                            <p>Use this option to automatically upload UDIs using our MedBoard template for bulk upload. If you wish to use this option, please contact us and we will guide you to fill the form and evaluate your needs/data.</p>

                            <p> Current UDI Upload Template version: v1.0</p>
                        </div>
                        <BulkImportUDIs />

                    </div>
                    : null}


            </div>


        </div>
    );
};





const SearchableCountrySelect = ({
    label,
    value,
    onChange,
    countries
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");

    const selected = countries.find(c => c.id == value);

    const filtered = countries.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div style={{ width: "100%", position: "relative" }}>
            {label}
            <br />

            <input
                type="text"
                value={isOpen ? search : (selected?.name || "")}
                placeholder="Search country..."
                onFocus={() => {
                    setIsOpen(true);
                    setSearch("");
                }}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setIsOpen(true);
                }}
                onBlur={() => {
                    setTimeout(() => setIsOpen(false), 150);
                }}
                style={{
                    width: "100%",
                    padding: "6px",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                }}
            />

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map(country => (
                            <div
                                key={country.id}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    onChange(country.id);
                                    setIsOpen(false);
                                    setSearch(country.name);
                                }}
                                style={{
                                    padding: "6px",
                                    cursor: "pointer"
                                }}
                            >
                                {country.name}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "6px", color: "#888" }}>
                            No results
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};







/*
USAGE:

<ProductTreeSelector
    onSelectionChange={(selectedIds) => {
        console.log(selectedIds);
    }}
/>

API RESPONSE FORMAT:

{
    Families: [
        { Id: 1, Name: "fam1" },
    ],
    Products: [
        { Id: 100, Name: "Prod1", FamilyId: 1 },
    ],
}
*/

const ProductTreeSelector = ({ onSelectionChange }) => {
    const [families, setFamilies] = useState([]);
    const [products, setProducts] = useState([]);

    const [selectedProducts, setSelectedProducts] = useState([]);

    const [productsExpanded, setProductsExpanded] = useState(false);

    const [expandedFamilies, setExpandedFamilies] = useState({});

    const productsCheckboxRef = useRef(null);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (onSelectionChange) {
            onSelectionChange(selectedProducts);
        }
    }, [selectedProducts]);

    const loadData = async () => {
        try {
            const response = await fetch(
                "/umbraco/api/RIMSRegistrations/FamiliesAndProducts/"
            );

            const data = await response.json();

            setFamilies(data.Families || []);
            setProducts(data.Products || []);
        } catch (err) {
            console.error("Failed loading products tree", err);
        }
    };

    const groupedFamilies = useMemo(() => {
        return families.map((family) => ({
            ...family,
            Products: products.filter(
                (product) => product.FamilyId === family.Id
            ),
        }));
    }, [families, products]);

    // -----------------------------
    // Selection Helpers
    // -----------------------------

    const isProductSelected = (productId) => {
        return selectedProducts.includes(productId);
    };

    const isFamilyFullySelected = (family) => {
        if (!family.Products.length) return false;

        return family.Products.every((p) =>
            selectedProducts.includes(p.Id)
        );
    };

    const isFamilyPartiallySelected = (family) => {
        const selectedCount = family.Products.filter((p) =>
            selectedProducts.includes(p.Id)
        ).length;

        return (
            selectedCount > 0 &&
            selectedCount < family.Products.length
        );
    };

    const areAllProductsSelected = () => {
        if (!products.length) return false;

        return products.every((p) =>
            selectedProducts.includes(p.Id)
        );
    };

    const areSomeProductsSelected = () => {
        return selectedProducts.length > 0;
    };

    // -----------------------------
    // Product Selection
    // -----------------------------

    const toggleProduct = (productId) => {
        setSelectedProducts((prev) => {
            if (prev.includes(productId)) {
                return prev.filter((id) => id !== productId);
            }

            return [...prev, productId];
        });
    };

    // -----------------------------
    // Family Selection
    // -----------------------------

    const toggleFamily = (family) => {
        const familyProductIds = family.Products.map((p) => p.Id);

        const fullySelected = familyProductIds.every((id) =>
            selectedProducts.includes(id)
        );

        if (fullySelected) {
            setSelectedProducts((prev) =>
                prev.filter((id) => !familyProductIds.includes(id))
            );
        } else {
            setSelectedProducts((prev) => [
                ...new Set([...prev, ...familyProductIds]),
            ]);
        }
    };

    // -----------------------------
    // Global Selection
    // -----------------------------

    const toggleAllProducts = () => {
        if (areAllProductsSelected()) {
            setSelectedProducts([]);
        } else {
            setSelectedProducts(products.map((p) => p.Id));
        }
    };

    // -----------------------------
    // Indeterminate Checkbox States
    // -----------------------------

    useEffect(() => {
        if (productsCheckboxRef.current) {
            productsCheckboxRef.current.indeterminate =
                areSomeProductsSelected() &&
                !areAllProductsSelected();
        }
    }, [selectedProducts]);

    // -----------------------------
    // Expand / Collapse
    // -----------------------------

    const toggleFamilyExpand = (familyId) => {
        setExpandedFamilies((prev) => ({
            ...prev,
            [familyId]: !prev[familyId],
        }));
    };

    return (
        <div style={{ width: "100%" }}>
            {/* ROOT */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: "600",
                }}
            >
                {/* CARET */}
                <span
                    style={{
                        cursor: "pointer",
                        width: "16px",
                        display: "inline-block",
                    }}
                    onClick={() =>
                        setProductsExpanded(!productsExpanded)
                    }
                >
                    {productsExpanded ? "▼" : "▶"}
                </span>

                {/* CHECKBOX */}
                <input
                    ref={productsCheckboxRef}
                    type="checkbox"
                    checked={areAllProductsSelected()}
                    onChange={toggleAllProducts}
                />

                {/* ICON */}
                <span>📦</span>

                {/* TITLE */}
                <span>Products</span>
            </div>

            {/* FAMILIES */}
            {productsExpanded && (
                <div style={{ marginLeft: "24px", marginTop: "8px" }}>
                    {groupedFamilies.map((family) => {
                        const familyCheckboxRef =
                            React.createRef();

                        setTimeout(() => {
                            if (familyCheckboxRef.current) {
                                familyCheckboxRef.current.indeterminate =
                                    isFamilyPartiallySelected(
                                        family
                                    );
                            }
                        }, 0);

                        return (
                            <div
                                key={family.Id}
                                style={{ marginBottom: "8px" }}
                            >
                                {/* FAMILY ROW */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    {/* CARET */}
                                    <span
                                        style={{
                                            cursor: "pointer",
                                            width: "16px",
                                            display:
                                                "inline-block",
                                        }}
                                        onClick={() =>
                                            toggleFamilyExpand(
                                                family.Id
                                            )
                                        }
                                    >
                                        {expandedFamilies[
                                            family.Id
                                        ]
                                            ? "▼"
                                            : "▶"}
                                    </span>

                                    {/* CHECKBOX */}
                                    <input
                                        ref={familyCheckboxRef}
                                        type="checkbox"
                                        checked={isFamilyFullySelected(
                                            family
                                        )}
                                        onChange={() =>
                                            toggleFamily(family)
                                        }
                                    />

                                    {/* ICON */}
                                    <span>📁</span>

                                    {/* NAME */}
                                    <span>{family.Name}</span>
                                </div>

                                {/* PRODUCTS */}
                                {expandedFamilies[family.Id] && (
                                    <div
                                        style={{
                                            marginLeft: "32px",
                                            marginTop: "6px",
                                        }}
                                    >
                                        {family.Products.map(
                                            (product) => (
                                                <div
                                                    key={
                                                        product.Id
                                                    }
                                                    style={{
                                                        display:
                                                            "flex",
                                                        alignItems:
                                                            "center",
                                                        gap: "8px",
                                                        marginBottom:
                                                            "4px",
                                                    }}
                                                >
                                                    {/* SPACER */}
                                                    <span
                                                        style={{
                                                            width:
                                                                "16px",
                                                        }}
                                                    />

                                                    {/* CHECKBOX */}
                                                    <input
                                                        type="checkbox"
                                                        checked={isProductSelected(
                                                            product.Id
                                                        )}
                                                        onChange={() =>
                                                            toggleProduct(
                                                                product.Id
                                                            )
                                                        }
                                                    />

                                                    {/* ICON */}
                                                    <span></span>

                                                    {/* NAME */}
                                                    <span>
                                                        {product.SKUCode}&nbsp;&nbsp;•&nbsp;&nbsp;{product.Name}
                                                    </span>
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};




const CertificatesDropdown = ({
    label = "",
    data = [],
    value = "",
    onChange = () => { },
    placeholder = "Select certificate",
    enableSearch = true,
    error = false,
    width = "100%"
}) => {
    
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    // ================= FILTER =================
    const filteredData = useMemo(() => {

        if (!enableSearch)
            return data;

        return data.filter(item =>
            (item?.Text || "")
                .toLowerCase()
                .includes(search.toLowerCase())
        );

    }, [data, search, enableSearch]);

    // ================= GROUP =================
    const groupedData = useMemo(() => {

        const grouped = filteredData.reduce((acc, item) => {

            const groupName = item?.Group?.Name || "Other";

            if (!acc[groupName])
                acc[groupName] = [];

            acc[groupName].push(item);

            return acc;

        }, {});

        // SORT COUNTRIES + CERTIFICATES
        return Object.fromEntries(

            Object.entries(grouped)

                // SORT COUNTRIES
                .sort(([groupA], [groupB]) =>
                    groupA.localeCompare(groupB)
                )

                // SORT CERTIFICATES
                .map(([groupName, items]) => [

                    groupName,

                    items.sort((a, b) =>
                        (a.Text || "")
                            .localeCompare(b.Text || "")
                    )

                ])

        );

    }, [filteredData]);

    // ================= SELECTED ITEM =================
    const selectedItem = data.find(
        item => item.Value == value
    );

    // ================= RENDER =================
    return (

        <div
            style={{
                width,
                position: "relative"
            }}
        >
            {label}
            <br />
            <input
                type="text"
                value={
                    isOpen
                        ? search
                        : (selectedItem?.Text || "")
                }
                placeholder={placeholder}
                className={`form-field-text ${error ? "form-field-error" : ""}`}
                style={{
                    width: "100%"
                }}
                onFocus={() => {
                    setIsOpen(true);
                    setSearch("");
                }}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setIsOpen(true);
                }}
                onBlur={() => {
                    setTimeout(() => {
                        setIsOpen(false);
                    }, 150);
                }}
            />

            {isOpen && (

                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "260px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >

                    {Object.keys(groupedData).length > 0 ? (

                        Object.entries(groupedData).map(
                            ([groupName, items]) => (

                                <div key={groupName}>

                                    {/* GROUP TITLE */}
                                    <div
                                        style={{
                                            padding: "8px 10px",
                                            fontWeight: "bold",
                                            background: "#f5f5f5",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    >
                                        {groupName}
                                    </div>

                                    {/* ITEMS */}
                                    {items.map(item => (

                                        <div
                                            key={item.Value}
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            onClick={() => {

                                                if (item.Disabled)
                                                    return;

                                                onChange(item);

                                                setSearch(item.Text);

                                                setIsOpen(false);

                                            }}
                                            style={{
                                                padding: "8px 10px",
                                                cursor: item.Disabled
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity: item.Disabled
                                                    ? 0.5
                                                    : 1,
                                                background:
                                                    value == item.Value
                                                        ? "#f0f7ff"
                                                        : "#fff"
                                            }}
                                        >

                                            {item.Text}

                                        </div>

                                    ))}

                                </div>

                            )
                        )

                    ) : (

                        <div
                            style={{
                                padding: "8px 10px",
                                color: "#888"
                            }}
                        >
                            No results
                        </div>

                    )}

                </div>

            )}

        </div>

    );

};





const ProductsDropdown = ({
    label = "",
    data = {
        Families: [],
        Products: []
    },
    value = "",
    onChange = () => { },
    placeholder = "Select product",
    enableSearch = true,
    error = false,
    width = "100%"
}) => {
    console.log("value", value);
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    // ================= CREATE FAMILY MAP =================
    const familyMap = useMemo(() => {

        const map = {};

        (data?.Families || []).forEach(family => {

            map[family.Id] = family.Name;

        });

        return map;

    }, [data]);

    // ================= FILTER PRODUCTS =================
    const filteredProducts = useMemo(() => {

        let products = data?.Products || [];

        if (!enableSearch)
            return products;

        return products.filter(product => {

            const text = `
                ${product?.Name || ""}
                ${product?.SKUCode || ""}
                ${familyMap[product?.FamilyId] || ""}
            `.toLowerCase();

            return text.includes(search.toLowerCase());

        });

    }, [data, search, enableSearch, familyMap]);

    // ================= GROUP + SORT =================
    const groupedProducts = useMemo(() => {

        const grouped = filteredProducts.reduce((acc, product) => {

            const familyName =
                familyMap[product?.FamilyId] || "Other";

            if (!acc[familyName])
                acc[familyName] = [];

            acc[familyName].push(product);

            return acc;

        }, {});

        // SORT FAMILIES + PRODUCTS
        return Object.fromEntries(

            Object.entries(grouped)

                // SORT FAMILIES
                .sort(([familyA], [familyB]) =>
                    familyA.localeCompare(familyB)
                )

                // SORT PRODUCTS
                .map(([familyName, items]) => [

                    familyName,

                    items.sort((a, b) =>
                        (a.Name || "")
                            .localeCompare(b.Name || "")
                    )

                ])

        );

    }, [filteredProducts, familyMap]);

    // ================= SELECTED PRODUCT =================
    const selectedProduct = useMemo(() => {
        return (data?.Products || []).find(
            product => String(product.Id) === String(value)
        );
    }, [data, value]);



    useEffect(() => {
        if (selectedProduct) {
            setSearch(`${selectedProduct.Name} (${selectedProduct.SKUCode})`);
        } else {
            setSearch("");
        }
    }, [selectedProduct]);




    // ================= RENDER =================
    return (

        <div
            style={{
                width,
                position: "relative"
            }}
        >
            {label}
            <br />
            <input
                type="text"
                value={
                    isOpen
                        ? search
                        : selectedProduct
                            ? `${selectedProduct.Name} (${selectedProduct.SKUCode})`
                            : ""
                }
                placeholder={placeholder}
                className={`form-field-text ${error ? "form-field-error" : ""}`}
                style={{
                    width: "100%"
                }}
                onFocus={() => {
                    setIsOpen(true);
                    setSearch("");
                }}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setIsOpen(true);
                }}
                onBlur={() => {
                    setTimeout(() => {
                        setIsOpen(false);
                    }, 150);
                }}
            />

            {isOpen && (

                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "300px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >

                    {Object.keys(groupedProducts).length > 0 ? (

                        Object.entries(groupedProducts).map(
                            ([familyName, items]) => (

                                <div key={familyName}>

                                    {/* FAMILY TITLE */}
                                    <div
                                        style={{
                                            padding: "8px 10px",
                                            fontWeight: "bold",
                                            background: "#f5f5f5",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    >
                                        {familyName}
                                    </div>

                                    {/* PRODUCTS */}
                                    {items.map(product => (

                                        <div
                                            key={product.Id}
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            onClick={() => {

                                                onChange(product);

                                                setSearch(
                                                    `${product.SKUCode}&nbsp;&nbsp;•&nbsp;&nbsp;${product.Name}`
                                                );

                                                setIsOpen(false);

                                            }}
                                            style={{
                                                padding: "10px",
                                                cursor: "pointer",
                                                background:
                                                    value == product.Id
                                                        ? "#f0f7ff"
                                                        : "#fff",
                                                borderBottom: "1px solid #f5f5f5"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 500
                                                }}
                                            >
                                                {product.Name}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#666",
                                                    marginTop: "2px"
                                                }}
                                            >
                                                {product.SKUCode}
                                            </div>

                                        </div>

                                    ))}

                                </div>

                            )
                        )

                    ) : (

                        <div
                            style={{
                                padding: "10px",
                                color: "#888"
                            }}
                        >
                            No results
                        </div>

                    )}

                </div>

            )}

        </div>

    );

};






export default AddItemPopup;